import React, {useEffect, useState} from 'react';

import styles from './RmdInputBox.module.scss';

function RmdInputBox({
  handleValueChange,
  hasError,
  balanceFund,
  defaultValue = '',
  defaultPlaceHolder = '',
  changePlaceHolder = '',
  intOnly,
  openBox,
}) {
  const [value, setValue] = useState(defaultValue);
  const [placeHolder, setPlaceholder] = useState(defaultPlaceHolder);
  /* eslint-disable */
  useEffect(() => {
    setPlaceholder(defaultPlaceHolder);
    setValue('');
    handleValueChange(defaultValue);
  }, [changePlaceHolder]);
  /* eslint-enable */
  const handleChange = (e) => {
    let val = e.target.value;
    if (!isNaN(val) && val.length < 6 && fixFor2Decimal(val)) {
      val = Number(val);
      if (val >= 0 && val <= 100) {
        setValue(
          !intOnly ? e.target.value : parseInt(Number(e.target.value) || 0)
        );
        handleValueChange(e.target.value);
      }
    }
    if (val === '.') {
      setValue('0.');
      handleValueChange('0.');
    }
    if (!Boolean(val)) {
      handleValueChange('0');
    }
  };

  const fixFor2Decimal = (val) => {
    const splitList = val.split('.');
    if (splitList.length > 1) {
      return splitList[1].length <= 2;
    }
    return true;
  };

  const handleFocus = () => {
    setPlaceholder('');
  };

  const handleBlur = () => {
    if (value === '' || value === null) {
      setPlaceholder(defaultPlaceHolder);
    }
  };

  return (
    <div
      className={`${styles['input-wrapper']} ${
        (hasError || balanceFund) && styles['error']
      } ${openBox && styles['tax-input-wrapper']}`}
    >
      <input
        className={`${styles['input-field']} ${
          (hasError || balanceFund) && styles['error']
        }`}
        placeholder={placeHolder}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        type="text"
        value={value}
      />
      <div className={styles['percent']}>%</div>
    </div>
  );
}

export default RmdInputBox;
